import { Link } from 'react-router-dom';
import { GUIDES } from '../data/guides';
import { HELP_TITLE } from '../data/helpChoosing';

// "Help choosing": 2 or 3 links to the AC guides that fit this page (30 Oct
// 2026). Links come from data/helpChoosing.js, which scripts/prerender.js
// writes into the pre-rendered HTML too. The site's own card look: white,
// gray-200 border, blue on hover.

export const LIVE_GUIDE_SLUGS = GUIDES.filter((g) => g.live && g.slug).map((g) => g.slug);

export default function HelpChoosing({ links, className = 'mt-10' }) {
  if (!links || !links.length) return null;
  return (
    <section aria-labelledby="help-choosing-h" className={className} data-testid="help-choosing">
      <h2 id="help-choosing-h" className="text-[15px] font-semibold text-gray-900">{HELP_TITLE}</h2>
      <div className="mt-2 grid gap-2 sm:grid-cols-3">
        {links.map((l) => (
          <Link key={l.href} to={l.href}
            className="flex items-center justify-between gap-3 rounded-xl border border-gray-200 bg-white p-3.5 transition hover:border-blue-400">
            <span className="min-w-0">
              <span className="block text-[14px] font-semibold leading-snug text-gray-900">{l.title}</span>
              <span className="mt-0.5 block text-[13px] leading-snug text-gray-600">{l.text}</span>
            </span>
            <svg viewBox="0 0 24 24" className="h-4 w-4 shrink-0 text-blue-700" fill="none" stroke="currentColor"
              strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M9 6l6 6-6 6" />
            </svg>
          </Link>
        ))}
      </div>
    </section>
  );
}
